import { IMockProps, ErrorResponseCodeType } from '_core/types';
import MocksDef from './MocksDef';

import { CODE_ERRORS, ENDPOINT_API_PATH } from '../Definitions/TokenSmsDef';

const autoGenerateSuccess = (phoneNumber: string) => {
  const validateDocumentSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'POST',
      path: ENDPOINT_API_PATH,
      body: {
        phoneNumber,
      },
    },
    configResponse: {
      status: 200,
      data: {},
      headers: {},
    },
  };
  return validateDocumentSuccess;
};

const autoGenerateSuccessToken = autoGenerateSuccess(MocksDef.SMS_NUMBER);

const generatedSuccessMocks = [autoGenerateSuccessToken];

const autoGenerate = (phoneNumber: string) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const body = {
        phoneNumber: `${phoneNumber.slice(0, -1)}${index}`,
      };
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'POST',
          path: ENDPOINT_API_PATH,
          body,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};
const autoGenerateErrorsMock = () => {
  const responseCPF = autoGenerate(MocksDef.SMS_NUMBER);
  return [...responseCPF];
};

const errorsGenerated = autoGenerateErrorsMock();

const ValidateDocumentMocks = [...generatedSuccessMocks, ...errorsGenerated];
export default ValidateDocumentMocks;
